import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  ZigZagNoHeadingNoButtonInitModel, ZigZagNoHeadingNoButtonInitVariables,
  ZigZagNoHeadingNoButtonModel,
  ZigZagNoHeadingNoButtonVariables
} from '../../../../../models/email-template/zigzag-no-heading-no-button.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-zigzag-no-heading-no-button',
    imports: [
        CommonModule,
        NotificationComponent,
        ReactiveFormsModule,
        BlockTextComponent,
        PinComponent,
    ],
    templateUrl: './zigzag-no-heading-no-button.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './zigzag-no-heading-no-button.scss'
})
export class ZigZagNoHeadingNoButtonComponent extends BaseComponent implements OnInit {
  @Input() block: ZigZagNoHeadingNoButtonModel = new ZigZagNoHeadingNoButtonInitModel()
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new ZigZagNoHeadingNoButtonInitVariables()
    }
  }

  //placeholders:
  imagePlaceholder: string = 'Image';
  imageHrefPlaceholder: string = 'Enter Image Redirect Link';
  imageAltPlaceholder: string = 'Enter Image Alt Text';
  textPlaceholder: string = 'Enter Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof ZigZagNoHeadingNoButtonVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof ZigZagNoHeadingNoButtonVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
